import { render, staticRenderFns } from "./orderFollowPeo.vue?vue&type=template&id=05da5578&scoped=true"
import script from "./orderFollowPeo.vue?vue&type=script&lang=js"
export * from "./orderFollowPeo.vue?vue&type=script&lang=js"
import style0 from "./orderFollowPeo.vue?vue&type=style&index=0&id=05da5578&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05da5578",
  null
  
)

export default component.exports